<div nz-row nzJustify="flex-start" [nzGutter]=[12,12]>
    <ng-container *ngFor="let app of currentUser.applications">
        <div nz-col [nzLg]="{span:4}" [nzSm]="{span:8}" [nzXs]="{span:12}" class="apps_card">
            <ng-template #coverTemplate>
                <div class="cover-app" >
                    <mat-icon [svgIcon]="app.icon_class"></mat-icon>
                </div>
            </ng-template>
            <nz-card nzHoverable [nzCover]="coverTemplate" class="card-default" [nzBordered]="false"
                (click)="navigate(app)">
                <h3>{{app.label}}</h3>
            </nz-card>
        </div>
    </ng-container>
</div>
